import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { BoundingBox, FileText } from "@phosphor-icons/react";

interface Props {
  maxRows?: number;
  flows: {
    id: string;
    name: string;
    folder: { name: string };
    createdAt: Date;
    isForm: boolean;
    spaceId: string;
  }[];
}
const FlowsTable: React.FC<Props> = ({ flows, maxRows }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { semanticColors } = theme;

  const slicedFlows = maxRows ? flows.slice(0, maxRows) : flows;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        padding: 0,
        margin: 0,
      }}
    >
      <Paper
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          mb: 0,
          boxShadow: "none",
          padding: 0,
          margin: 0,
          backgroundColor: semanticColors.backgroundSecondary,
        }}
      >
        <TableContainer
          sx={{
            width: "100%",
            flex: 1,
            overflow: "auto",
            padding: 0,
            margin: 0,
          }}
        >
          <Table
            stickyHeader
            size={"medium"}
            sx={{ width: "100%", tableLayout: "auto" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: semanticColors.background,
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    color: semanticColors.textPrimary,
                  }}
                >
                  Name
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: semanticColors.background,
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    color: semanticColors.textPrimary,
                  }}
                >
                  Folder
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    backgroundColor: semanticColors.background,
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    color: semanticColors.textPrimary,
                  }}
                >
                  Creation Date
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {slicedFlows.map((flow) => {
                return (
                  <TableRow
                    hover
                    onClick={() => {
                      if (flow?.isForm) {
                        navigate(
                          `/interface/${flow.id}?spaceId=${flow?.spaceId}`,
                        );
                        return;
                      }

                      navigate(`/agent/${flow.id}`);
                    }}
                    tabIndex={-1}
                    key={flow?.id}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: semanticColors.surfaceHover,
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        color: semanticColors.textPrimary,
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        backgroundColor: semanticColors.backgroundSecondary,
                      }}
                    >
                      {flow?.isForm ? (
                        <FileText size={16} weight="fill" color="#3650DE" />
                      ) : (
                        <BoundingBox size={16} weight="fill" color="#3650DE" />
                      )}
                      <Typography sx={{ color: semanticColors.textPrimary }}>
                        {flow?.name}
                      </Typography>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: semanticColors.textPrimary,
                        fontSize: "14px",
                        backgroundColor: semanticColors.backgroundSecondary,
                      }}
                    >
                      {flow?.folder?.name}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: semanticColors.textPrimary,
                        fontSize: "12px",
                        backgroundColor: semanticColors.backgroundSecondary,
                      }}
                      align="right"
                    >
                      {moment(flow?.createdAt).format("MM/DD/YYYY")}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default FlowsTable;
